import { render, staticRenderFns } from "./ModificacionCertificacionPage.vue?vue&type=template&id=3c487fc8"
import script from "./ModificacionCertificacionPage.js?vue&type=script&lang=js&external"
export * from "./ModificacionCertificacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports